export const Colors = {
    gray: '#686868',
    darkGray: '#282828',
    lightGray: '#C0C0C0',
    lightGrayBorder: '#F5F5F5',
    blue: '#4A52BB',
    lightBlue: '#F3F1FF',
    deepBlue: '#454caf',
    orange: '#F3A712',
    deepOrange: '#de9a11',
    lightOrange: '#FFE710',
    red: '#FF2727',
    error: '#d43737',
    lightRed: '#FFCFCF',
    green: '#00CB14',
    purple: '#752AFF',
    darkPurple: 'rgba(117, 42, 255, 0.4)',
    lightGreen: '#E5FAE6',
    white: '#FFFFFF',
    inputBorder: '#E7E7E7',
    tableBorder: '#E3E3E3',
    darkInputBorder: '#8f8f9d',
    inputHover: '#999a',
    sand: '#ffe2a9',
    darkBlack: '#2c2c2c',
    lightBlack: '#2c2c2c',
    black: '#000000',
    formBackground: '#FCFAFF',
    buttonGradientStart: '#393bff',
    buttonGradientEnd: '#9820ff',
    buttonHover: '#c09031',
    borderColor: '#4a55bd',
    borderStrokeColor: '#EFF0F6',
    consultationButton: '#5054bc',
    switcherTextColor: '#323842FF',
    salesNextBtn: '#8353E2FF',
    salesNextBtnHover: '#6025d8ff',
    hoverColor: '#f5f5f5',
    linkBlue: '#1091F4',
    revampedPurple: '#6025D8',
    retainerBackground: '#FDFAFE',
    retainerTextColor: '#171A1F',
    tableHeader: '#F2F1F4',
    darkTableRow: '#FBFBFB',
};
